import { render } from "./DoctorScheduleCard.vue?vue&type=template&id=6f79f467"
import script from "./DoctorScheduleCard.vue?vue&type=script&lang=js"
export * from "./DoctorScheduleCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__